module.exports = __webpack_public_path__ + "img/builder-6.76d640fa.jpg";